import React from "react";
import { Link } from "react-router-dom";
import { Meta } from "../components/SEO";

export default function NotFoundPage() {
  // React SPA cannot set an HTTP 404 status client-side. To ensure crawlers
  // treat unknown URLs as truly missing, the frontend host / CDN must be
  // configured to return HTTP 404 for the SPA fallback route. In the meantime
  // we always emit noindex so Google won't accidentally index a 200-OK "soft
  // 404" page.
  React.useEffect(() => {
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "noindex,follow");
  }, []);

  return (
    <>
      <Meta title="Pagina niet gevonden (404) | Koning Aannemersbedrijf" noindex />
      <section className="min-h-[70vh] flex items-center" data-testid="notfound-page">
        <div className="max-w-[1100px] mx-auto px-6 md:px-12 lg:px-20 text-center">
          <div className="font-display text-koning-gold text-7xl md:text-9xl tracking-tight">404</div>
          <h1 className="font-display text-3xl md:text-5xl text-white mt-4">Pagina niet gevonden</h1>
          <p className="mt-4 text-koning-muted">De pagina die u zoekt bestaat niet of is verplaatst.</p>
          <div className="mt-8 flex items-center justify-center gap-3">
            <Link to="/" className="btn-gold">Terug naar home</Link>
            <Link to="/diensten" className="btn-outline">Bekijk diensten</Link>
          </div>
        </div>
      </section>
    </>
  );
}
